export enum InvoiceItemTypes {
    Unknown = 0,
    Inventory = 1,
    Service = 2,
    Group = 3,
    Pick = 4,
    Dispensing = 5,
}
